import PERSON_IMG from "../../images/members/person-image.jpg";

// Club Members Batch 2024-2025
import DEVANG_IMG from "../../images/members/club-members/DevangVaghani.jpg";
import JEET_IMG from "../../images/members/club-members/JeetPatel.jpg";
import KAIVAL_IMG from "../../images/members/club-members/KaivalMehta.jpg";
import MANOJ_IMG from "../../images/members/club-members/ManojDhundhalva.jpg";
import PARJANYA_IMG from "../../images/members/club-members/ParjanyaRajput.jpg";
import RAMYA_IMG from "../../images/members/club-members/RamyaShah.png";
import RIDDHI_IMG from "../../images/members/club-members/RiddhiMistry.jpg";
import SHRUTI_IMG from "../../images/members/club-members/ShrutiChoudhary.jpeg";
import SWAYAM_IMG from "../../images/members/club-members/SwayamHingu.jpg";
import TANMAY_IMG from "../../images/members/club-members/TanmaySingh.jpg";
import VENIL_IMG from "../../images/members/club-members/VenilVekariya.jpg";

// Club Members Batch 2025-2026
import ZEELKUMARDADHANIYA_IMG from "../../images/members/club-members/new-members/ZeelkumarDadhaniya.jpg";
import BRINDASORATHIYA_IMG from "../../images/members/club-members/new-members/BrindaSorathiya.jpg";
import PRIYANSHIKAPATEL_IMG from "../../images/members/club-members/new-members/priyanshikapatel.jpg";
import NIDHIDODIYA_IMG from "../../images/members/club-members/new-members/NidhiDodiya.jpeg";
import DHYEYPAREKH_IMG from "../../images/members/club-members/new-members/DhyeyParekh.jpg";
import AAYUSHGOYAL_IMG from "../../images/members/club-members/new-members/AayushGoyal.jpg";
import AARYASHAH_IMG from "../../images/members/club-members/new-members/AaryaShah.jpg";
import MALHARPRAJAPATI_IMG from "../../images/members/club-members/new-members/MalharPrajapati.jpeg";
import VASHISHTPURANI_IMG from "../../images/members/club-members/new-members/VashishtPurani.jpg";
import VRUNKANSARA_IMG from "../../images/members/club-members/new-members/VrundKansara.jpg";
import CHINMAIKEWLANI_IMG from "../../images/members/club-members/new-members/ChinmaiKewlani.jpg";
import RUDRADESAI_IMG from "../../images/members/club-members/new-members/RudraDesai.jpg";

// Mentors Batch 2023-2024
import AKASHSINGH_IMG from "../../images/members/mentors-2023-2024/AkashSingh.jpg";
import ASISHJOEL_IMG from "../../images/members/mentors-2023-2024/AsishJoel.jpg";
import BHAVYASHAH_IMG from "../../images/members/mentors-2023-2024/BhavyaShah.jpg";
import CHAITANYASHETH_IMG from "../../images/members/mentors-2023-2024/ChaitanyaSheth.jpg";
import HARSHMUNGARA_IMG from "../../images/members/mentors-2023-2024/HarshMungara.jpg";
import JALPPATEL_IMG from "../../images/members/mentors-2023-2024/JalpPatel.jpg";
import JAYCHEVLI_IMG from "../../images/members/mentors-2023-2024/JayChevli.jpg";
import TEESHAVARLANI_IMG from "../../images/members/mentors-2023-2024/TeeshaVarlani.jpg";
import RUCHIKAAMIN_IMG from "../../images/members/mentors-2023-2024/RuchikaAmin.jpg";
import RUSHIVAGHELA_IMG from "../../images/members/mentors-2023-2024/RushiVaghela.jpg";
import SHASHANKUPADHYAY_IMG from "../../images/members/mentors-2023-2024/ShashankUpadhyay.jpg";
import SRIKARPADALIYA_IMG from "../../images/members/mentors-2023-2024/SrikarPadaliya.jpg";
import TAKSHAYMAKADIA_IMG from "../../images/members/mentors-2023-2024/TakshayMakadia.jpg";
import VRISHINSHAH_IMG from "../../images/members/mentors-2023-2024/VrishinShah.jpg";

// Mentors
import ADITSHAH_IMG from "../../images/members/mentors/AditShah.jpg";
import ARPANSHINGALA_IMG from "../../images/members/mentors/ArpanShingala.jpg";
import ATMANSHAH_IMG from "../../images/members/mentors/AtmanShah.jpg";
import DHIRAJNARSINGHANI_IMG from "../../images/members/mentors/DhirajNarsinghani.jpg";
import DHWANIUPADHYAY_IMG from "../../images/members/mentors/DhwaniUpadhyay.jpg";
import DISHANTVYAS_IMG from "../../images/members/mentors/DishantVyas.jpg";
import HARSHPATEL_IMG from "../../images/members/mentors/HarshPatel.jpg";
import ISHASHAH_IMG from "../../images/members/mentors/IshaShah.jpg";
import JINALPRAJAPATI_IMG from "../../images/members/mentors/JinalPrajapati.jpg";
import KAUSHALPATEL_IMG from "../../images/members/mentors/KaushalPatel.jpg";
import VIDHIBADRAKIYA_IMG from "../../images/members/mentors/VidhiBadrakiya.jpg";
import VISHESHPATEL_IMG from "../../images/members/mentors/VisheshPatel.jpg";
import ZIYAMKHAN_IMG from "../../images/members/mentors/ZiyamKhan.jpg";

export const CLUB_MEMBERS_2024_2025 = [
  {
    name: "Parjanya Rajput",
    photo: PARJANYA_IMG,
    position: "Convenor",
    primary_techstack: "Android Kotlin, React Native and Flutter",
    about: "Enthusiastic Developer who just loves building random stuffs",
    github: "https://github.com/parjanya-rajput",
    linkedin: "https://www.linkedin.com/in/parjanya-rajput-9907ba249/",
  },
  {
    name: "Venil Vekariya",
    photo: VENIL_IMG,
    position: "Deputy Convenor",
    primary_techstack: "Machine Learning",
    about: "I am mainly interested in Machine Learning and its real-world applications. But, I am still excited to learn about new and upcoming technologies.",
    github: "https://github.com/venilv912",
    linkedin: "https://www.linkedin.com/in/venil-vekariya-87335b216",
  },
  {
    name: "Swayam Hingu",
    photo: SWAYAM_IMG,
    position: "Core member",
    primary_techstack: "Python and their Frameworks",
    about: "A passionate developer and mentor at the MSTC, Dedicated to contributing to the club's success by mentoring others, fostering innovation, and continuously learning through impactful projects.",
    github: "https://github.com/Swayam-Hingu",
    linkedin: "https://www.linkedin.com/in/swayam-hingu-b47a02248",
  },
  {
    name: "Manoj Dhundhalva",
    photo: MANOJ_IMG,
    position: "Core member",
    primary_techstack: "Full-Stack Web Developer",
    about: "I am enthusiastic about exploring new technologies and enjoy building innovative projects. I am also a competitive programmer and have a keen interest in problem-solving.",
    github: "https://github.com/ManojDhundhalva",
    linkedin: "https://www.linkedin.com/in/manoj-dhundhalva-62ba0b24b/",
  },
  {
    name: "Devang Vaghani",
    photo: DEVANG_IMG,
    position: "Core member",
    primary_techstack: "CP, MERN Stack",
    about: "As a competitive programmer, I am passionate about problem-solving and contributing to the coding community, while exploring new technologies.",
    github: "https://github.com/devangsvaghani",
    linkedin: "https://www.linkedin.com/in/devangsvaghani/",
  },
  {
    name: "Riddhi Mistry",
    photo: RIDDHI_IMG,
    position: "Core member",
    primary_techstack: "MERN Stack, SpringBoot",
    about: "I enjoy exploring new technologies based on my interests. Drawing and listening to music are also things I enjoy doing in my free time.",
    github: "https://github.com/Riddhi-1510",
    linkedin: "https://www.linkedin.com/in/riddhi-mistry-1bba63251/",
  },
  {
    name: "Tanmay Singh",
    photo: TANMAY_IMG,
    position: "Member",
    primary_techstack: "Flutter, App development",
    about: "A Flutter enthusiast currently learning machine learning, with a growing passion for data science and solving real-world problems through technology.",
    github: "https://github.com/10maysingh",
    linkedin: "http://www.linkedin.com/in/tanmay-singh-33a289243/",
  },
  {
    name: "Kaival Mehta",
    photo: KAIVAL_IMG,
    position: "Member",
    primary_techstack: "Python-Django",
    about: "I am tech enthusiast and always curious about the latest technologies. Apart from Django I am also familiar with ML,React and Competetive Programming stacks",
    github: "https://github.com/kaivalmehta",
    linkedin: "https://www.linkedin.com/in/kaival-mehta-548854253/",
  },
  {
    name: "Ramya Shah",
    photo: RAMYA_IMG,
    position: "Member",
    primary_techstack: "MERN Stack",
    about: "Passionate about Fullstack development",
    github: "https://github.com/Ramya-Shah",
    linkedin: "https://www.linkedin.com/in/ramya-shah-a70258253/",
  },
  {
    name: "Jeet Patel",
    photo: JEET_IMG,
    position: "Member",
    primary_techstack: "Html, CSS, Javascript, React JS",
    about: "I'm a frontend developer passionate about creating responsive and user-friendly interfaces, primarily using HTML, CSS, JavaScript and React.js",
    github: "https://github.com/jeet30042005",
    linkedin: "https://www.linkedin.com/in/jeet-patel-750a95258/",
  },
  {
    name: "Shruti Choudhary",
    photo: SHRUTI_IMG,
    position: "Member",
    primary_techstack: "MERN Stack",
    about: "I am currently trying to learn and build my skills in the field of MERN and Machine Learning.",
    github: "https://github.com/src3004",
    linkedin: "http://www.linkedin.com/in/shruti-ranjit-choudhary-63bbba250/",
  },
];

export const CLUB_MEMBERS_2025_2026 = [
  {
    name: "Zeelkumar Dadhaniya",
    photo: ZEELKUMARDADHANIYA_IMG,
    position: "Member",
    primary_techstack: "MERN Stack",
    about: "I'm Zeelkumar Dadhaniya, a passionate MERN stack developer who loves driving innovation ⚡, sharing knowledge 📚, and bringing communities together 🌟 through exciting and impactful technical events.",
    github: "https://github.com/zeeldadhaniya1895",
    linkedin: "https://www.linkedin.com/in/zeel-dadhaniya-79ab7b2b8/",
  },
  {
    name: "Brinda Sorathiya",
    photo: BRINDASORATHIYA_IMG,
    position: "Member",
    primary_techstack: "MERN Stack",
    about: "I'm skilled in the MERN stack and on expanding my knowledge in it. While building a foundation in ML-DL, aiming to explore these fields in greater depth.",
    github: "https://github.com/Brinda-Sorathiya",
    linkedin: "https://www.linkedin.com/in/brinda-sorathiya-a63a982a1/",
  },
  {
    name: "Ka. Patel Priyanshi Prafulbhai",
    photo: PRIYANSHIKAPATEL_IMG,
    position: "Member",
    primary_techstack: "Django, Machine Learning",
    about: "I am Priyanshi Ka. Patel, currently pursuing my MTech in Information and Communication Technology (ICT) with a specialization in Machine Learning from DAIICT. I hold a BE in Computer Engineering from GEC Gandhinagar.",
    github: "https://github.com/Priyanshi89",
    linkedin: "https://www.linkedin.com/in/priyanshi-ka-patel-825a99246/",
  },
  {
    name: "Nidhi Dodiya",
    photo: NIDHIDODIYA_IMG,
    position: "Member",
    primary_techstack: "MERN Stack",
    about: "Tech enthusiast with a strong DSA foundation, pursuing web development and competitive programming. Committed to enhancing skills and expanding knowledge to broaden expertise.",
    github: "https://github.com/NidhiDodiya1014",
    linkedin: "https://www.linkedin.com/in/nidhi-dodiya-30bbab303/",
  },
  {
    name: "Dhyey Parekh",
    photo: DHYEYPAREKH_IMG,
    position: "Member",
    primary_techstack: "MERN Stack",
    about: "Passionate Developer looking to build something that can bring impact in Real Life.",
    github: "https://github.com/dhyey2075",
    linkedin: "https://www.linkedin.com/in/dhyey-parekh-b7bb49281/",
  },
  {
    name: "Aayush Goyal",
    photo: AAYUSHGOYAL_IMG,
    position: "Member",
    primary_techstack: "MERN Stack and Blockchain development",
    about: "Student and Developer",
    github: "https://github.com/Aayushgoyal00",
    linkedin: "https://www.linkedin.com/in/aayush-goyal00/",
  },
  {
    name: "Aarya Shah",
    photo: AARYASHAH_IMG,
    position: "Member",
    primary_techstack: "HTML, CSS, JS, bootstrap, wordpress, php, ms SQL, My SQL",
    about: "Always ready to learn new technologies.",
    github: "https://github.com/aaryashah1010",
    linkedin: "https://www.linkedin.com/in/aarya-shah1104",
  },
  {
    name: "Malhar Prajapati",
    photo: MALHARPRAJAPATI_IMG,
    position: "Member",
    primary_techstack: "Machine Learning",
    about: "Hello, my name is Malhar Prajapati. I am pursuing my MSc in IT, currently in the first year, and I aspire to build a career in machine learning with a strong interest in data science and technology.",
    github: "https://github.com/malhar2460",
    linkedin: "http://www.linkedin.com/in/malhar2460",
  },
  {
    name: "Vashisht Purani",
    photo: VASHISHTPURANI_IMG,
    position: "Member",
    primary_techstack: "MERN, ML/NLP",
    about: "Passionate Web-Developer with interests in Machine Learning and Natural Language Processing.",
    github: "https://github.com/vashishtpurani",
    linkedin: "https://www.linkedin.com/in/vashisht-purani-a412b2240/",
  },
  {
    name: "Vrund Hemang Kansara",
    photo: VRUNKANSARA_IMG,
    position: "Member",
    primary_techstack: "Python GUI",
    about: "My techstack is about creating GUI using Python and I am also interested in exploring other frameworks in python",
    github: "https://github.com/VrundDA",
    linkedin: "https://www.linkedin.com/in/vrund-hemang-kansara-1963952a8",
  },
  {
    name: "Chinmai Kewlani",
    photo: CHINMAIKEWLANI_IMG,
    position: "Member",
    primary_techstack: "React Native",
    about: `I'm Chinmai Kewlani, Tech enthusiast, learning and exploring world of tech.`,
    github: "https://github.com/chinmaiKewlani",
    linkedin: "https://www.linkedin.com/in/chinmai-kewlani-688568218/",
  },
  {
    name: "Rudra Desai",
    photo: RUDRADESAI_IMG,
    position: "Member",
    primary_techstack: "CP, Python GUI",
    about: `Being a competitive programmer, I am excited about problem-solving and contributing to the coding community.`,
    github: "https://github.com/desairudra",
    linkedin: "https://www.linkedin.com/in/desai-rudra-b854441a2/",
  },
];

export const MENTORS_2023_2024 = [
  {
    name: "Shashank Upadhyay",
    photo: SHASHANKUPADHYAY_IMG,
    position: "Convenor[2023] & Deputy Convenor[2024]",
    github: "https://github.com/shashank-u03",
    linkedin: "https://www.linkedin.com/in/shashank-upadhyay-686422226/",
  },
  {
    name: "Vrishin Shah",
    photo: VRISHINSHAH_IMG,
    position: "Deputy Convenor[2023] & Convenor[2024]",
    github: "https://github.com/PicantaData",
    linkedin: "https://www.linkedin.com/in/vrishin-shah-53920b150/",
  },
  {
    name: "Asish Joel",
    photo: ASISHJOEL_IMG,
    position: "Core Member[2022-2024]",
    github: "https://github.com/AsishJoel",
    linkedin: "http://www.linkedin.com/in/asishjoel",
  },
  {
    name: "Jalp Patel",
    photo: JALPPATEL_IMG,
    position: "Core Member[2022-2024]",
    github: "https://github.com/JKP0495",
    linkedin: "https://www.linkedin.com/in/jalp-patel-502b20225/",
  },
  {
    name: "Srikar Padaliya",
    photo: SRIKARPADALIYA_IMG,
    position: "Core Member[2022-2024]",
    github: "https://github.com/srikarpadaliya",
    linkedin: "https://www.linkedin.com/in/srikar-padaliya-93998a283/",
  },
  {
    name: "Takshay Makadia",
    photo: TAKSHAYMAKADIA_IMG,
    position: "Core Member[2022-2024]",
    github: "https://github.com/Takshay-Makadia",
    linkedin: "https://www.linkedin.com/in/takshay-makadia-712a38251/",
  },
  {
    name: "Akash Singh",
    photo: AKASHSINGH_IMG,
    position: "Member[2023-2024]",
    github: "https://github.com/iakash-singh",
    linkedin: "https://www.linkedin.com/in/akash-singh-448960202/",
  },
  {
    name: "Bhavya Shah",
    photo: BHAVYASHAH_IMG,
    position: "Member[2022-2024]",
    github: "http://mstc.daiict.ac.in/members",
    linkedin: "https://www.linkedin.com/in/bhavya-shah-9a7550233/",
  },
  {
    name: "Chaitanya Sheth",
    photo: CHAITANYASHETH_IMG,
    position: "Member[2022-2024]",
    github: "https://github.com/Chaitanya-030",
    linkedin: "http://www.linkedin.com/in/chaitanya-sheth",
  },
  {
    name: "Harsh Mungara",
    photo: HARSHMUNGARA_IMG,
    position: "Member[2022-2024]",
    github: "https://github.com/Harsh62004",
    linkedin: "https://www.linkedin.com/in/harsh-mungara-b54b60226/",
  },
  {
    name: "Jay Chevli",
    photo: JAYCHEVLI_IMG,
    position: "Member[2023-2024]",
    github: "https://github.com/JayChevli18",
    linkedin: "https://www.linkedin.com/in/jay-chevli-a79893241/",
  },
  {
    name: "Ruchika Amin",
    photo: RUCHIKAAMIN_IMG,
    position: "Member[2022-2024]",
    github: "https://github.com/Ruchii8803",
    linkedin: "https://www.linkedin.com/in/ruchika-amin-105b97251/",
  },
  {
    name: "Rushi Vaghela",
    photo: RUSHIVAGHELA_IMG,
    position: "Member[2022-2024]",
    github: "https://github.com/Rushi-Vaghela",
    linkedin: "https://www.linkedin.com/in/rushi-vaghela-3b16b0217",
  },
  {
    name: "Teesha Varlani",
    photo: TEESHAVARLANI_IMG,
    position: "Member[2023-2024]",
    github: "https://github.com/teesha-varlani",
    linkedin: "https://www.linkedin.com/in/teesha-varlani-470301204",
  },
];

export const MENTORS = [
  {
    name: "Harsh Patel",
    photo: HARSHPATEL_IMG,
    position: "Convenor [2022-23]",
    github: "https://github.com/harshpatel2212/",
    linkedin: "https://www.linkedin.com/in/harshumakantpatel/",
  },
  {
    name: "Vishesh Patel",
    photo: VISHESHPATEL_IMG,
    position: "Convenor [2022-2023]",
    github: "https://github.com/vishesh147",
    linkedin: "https://www.linkedin.com/in/vishesh-patel-5337231bb/",
  },
  {
    name: "Arpan Shingala",
    photo: ARPANSHINGALA_IMG,
    position: "Core Member [2022-2023]",
    github: "https://github.com/arpan-vs",
    linkedin: "https://www.linkedin.com/in/arpan-shingala-ba2128202/",
  },
  {
    name: "Isha Shah",
    photo: ISHASHAH_IMG,
    position: "Core Member [2022-2023]",
    github: "https://github.com/JKP0495",
    linkedin: "https://www.linkedin.com/in/jalp-patel-502b20225/",
  },
  {
    name: "Kaushal Patel",
    photo: KAUSHALPATEL_IMG,
    position: "Core Member [2022-2023]",
    github: "https://github.com/krazykaushal",
    linkedin: "https://www.linkedin.com/in/kaushal-patel-65480710a/",
  },
  {
    name: "Kunj Patel",
    photo: PERSON_IMG,
    position: "Core Member [2022-2023]",
    github: "https://github.com/kunjpatel1402",
    linkedin: "https://www.linkedin.com/in/kunj-patel-0646a9211/",
  },
  {
    name: "Dhairya Parikh",
    photo: PERSON_IMG,
    position: "Member [2022-2023]",
    github: "#",
    linkedin: "#",
  },
  {
    name: "Dhwani Upadhyay",
    photo: DHWANIUPADHYAY_IMG,
    position: "Member [2022-2023]",
    github: "https://github.com/u-dhwani",
    linkedin: "https://www.linkedin.com/in/dhwani-upadhyay-036755224/",
  },
  {
    name: "Harsh Prajapati",
    photo: PERSON_IMG,
    position: "Member [2022-2023]",
    github: "#",
    linkedin: "#",
  },
  {
    name: "Keshav Somani",
    photo: PERSON_IMG,
    position: "Member [2022-23]",
    github: "#",
    linkedin: "#",
  },
  {
    name: "Krunal Chhagani",
    photo: PERSON_IMG,
    position: "Member [2022-2023]",
    github: "#",
    linkedin: "#",
  },
  {
    name: "Nidhi Somaiya",
    photo: PERSON_IMG,
    position: "Member [2022-2023]",
    github: "#",
    linkedin: "#",
  },
  {
    name: "Pathik Patel",
    photo: PERSON_IMG,
    position: "Member [2022-2023]",
    github: "#",
    linkedin: "#",
  },
  {
    name: "Raghav Gorasia",
    photo: PERSON_IMG,
    position: "Member [2022-2023]",
    github: "#",
    linkedin: "#",
  },
  {
    name: "Rahul Upadhyay",
    photo: PERSON_IMG,
    position: "Member [2022-2023]",
    github: "#",
    linkedin: "#",
  },
  {
    name: "Shrey Pobaru",
    photo: PERSON_IMG,
    position: "Member [2022-2023]",
    github: "#",
    linkedin: "#",
  },
  {
    name: "Ziyam Khan",
    photo: ZIYAMKHAN_IMG,
    position: "Member [2022-2023]",
    github: "https://github.com/zimeckus",
    linkedin: "https://www.linkedin.com/in/ziyam-khan/",
  },
  {
    name: "Adit Shah",
    photo: ADITSHAH_IMG,
    position: "Convenor [2021-2022]",
    github: "https://github.com/adit19shah",
    linkedin: "https://www.linkedin.com/in/adit19shah/",
  },
  {
    name: "Dishant Vyas",
    photo: DISHANTVYAS_IMG,
    position: "Convenor [2021-2022]",
    github: "https://github.com/dishantvyas15",
    linkedin: "https://www.linkedin.com/in/dishantvyas15/",
  },
  {
    name: "Dev Choganwala",
    photo: PERSON_IMG,
    position: "Core Member[2021-2022]",
    github: "#",
    linkedin: "#",
  },
  {
    name: "Dhiraj Narsinghani",
    photo: DHIRAJNARSINGHANI_IMG,
    position: "Core Member[2021-2022]",
    github: "https://github.com/Dhiraj3118",
    linkedin: "https://www.linkedin.com/in/dhiraj-narsinghani/",
  },
  {
    name: "Jinal Prajapati",
    photo: JINALPRAJAPATI_IMG,
    position: "Core Member[2021-2022]",
    github: "https://github.com/jiiinal",
    linkedin: "https://www.linkedin.com/in/jinal-prajapatii/",
  },
  {
    name: "Jinesh Kanjiya",
    photo: PERSON_IMG,
    position: "Core Member[2021-2022]",
    github: "#",
    linkedin: "#",
  },
  {
    name: "Atman Shah",
    photo: ATMANSHAH_IMG,
    position: "Member [2021-2022]",
    github: "https://github.com/Atman-Shah",
    linkedin: "http://www.linkedin.com/in/atman-shah/",
  },
  {
    name: "Vidhi Badrakiya",
    photo: VIDHIBADRAKIYA_IMG,
    position: "Member [2021-2022]",
    github: "https://github.com/vidhibadrakiya",
    linkedin: "https://www.linkedin.com/in/vidhi-badrakiya-55272b19b/",
  },
];
